import * as React from "react";
import PropTypes from 'prop-types';

const SvgCartIcon = props => {
  if (props.id !== "_svgcarticon") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 28 28" {...props}><g fillRule="evenodd"><path fill="#636F79" d="M10.938 19.414a1.49 1.49 0 110 2.98 1.49 1.49 0 010-2.98zm6.618 0a1.489 1.489 0 110 2.978 1.489 1.489 0 01.001-2.978zM7.844 8.167c.334 0 .607.257.633.585l1.462 8.299h8.998l1.138-6.452a.635.635 0 111.252.221l-1.238 7.02a.674.674 0 01-.036.126.69.69 0 01-.652.463H9.477a.69.69 0 01-.608-.365.622.622 0 01-.077-.21L7.306 9.436H5.302a.635.635 0 010-1.27h2.542z" /><path stroke="#636F79" strokeLinecap="round" d="M11.084 11.083h7M14.583 14.583v-7" /></g></svg>;
};

SvgCartIcon.displayName = "_svgcarticon";
SvgCartIcon.propTypes = {
  id: PropTypes.string
};
SvgCartIcon.defaultProps = {
  id: ''
};
export default SvgCartIcon;